enum Roles {
  individual_free = "individual_free",
  individual_pro = "individual_pro",
  admin = "admin",
}

export default Roles;
